import { TextField } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { debounce } from '../../../../../../utils/debounce';

const TableFilter = ({ delay = 0, onChange }) => {
  const ref = useRef();

  const handleChangeFilter = debounce((value) => {
    onChange(value);
  }, delay);

  useEffect(() => {
    if (!ref) {
      return;
    }
    ref.current.addEventListener("input", () => {
      handleChangeFilter(ref.current.value);
    });
  }, [ref, handleChangeFilter]);

  return (
    <TextField
      inputRef={ref}
      name="text"
      variant="outlined"
      size="small"
      label="Filter"
    />
  );
}

export default TableFilter;
